import { useFormContext } from "react-hook-form";

import { AddressesSection } from "components/BaseForm";
import { useRegionCountry } from "hooks/useRegionCountry";

/**
 * The entity's addresses. Marking one primary fills an empty entity Region
 * and Country from its country, as the legacy form did, but never sets a
 * country outside the entity's region.
 */
const EntityAddressesSection = () => {
  const { getValues, setValue } = useFormContext();
  const { regionRecords } = useRegionCountry({ regionId: null });

  const handlePrimaryChange = index => {
    const country = getValues(`addresses.${index}.country`);
    const addressRegion = regionRecords.find(region =>
      region.countries.includes(country)
    );
    if (!addressRegion) return;

    const currentRegionId = getValues("region_id");
    if (currentRegionId == null) {
      setValue("region_id", addressRegion.id, { shouldDirty: true });
    }
    const entityRegion =
      currentRegionId == null
        ? addressRegion
        : regionRecords.find(region => region.id === currentRegionId);
    if (!getValues("country") && entityRegion?.countries.includes(country)) {
      setValue("country", country, { shouldDirty: true });
    }
  };

  return (
    <AddressesSection
      showPrimary
      showCoordinates
      onPrimaryChange={handlePrimaryChange}
    />
  );
};

export default EntityAddressesSection;
